import React from 'react';
import ReactTooltip from "react-tooltip"

const ModelImgMain = () => {
  return (
    <ReactTooltip delayHide={100} id='modelImgMain' type='info' effect='solid' className="text-center hooverTooltip">
      <span>ARRASTRA Y SUELTA LA IMAGEN DE LA VESPA</span>
    </ReactTooltip>
  );
};

const MoreModels = () => {
  return (
    <ReactTooltip id='moreModels' type='info' effect='solid' className="text-center">
      <span>CREA MODELOS</span>
    </ReactTooltip>
  );
};

const MoreVespas = () => {
  return (
    <ReactTooltip id='moreVespas' type='info' effect='solid' className="text-center">
      <span>CREA VESPAS <p>Recuerda que para crear una vespa <br/> debes de tener como mínimo un modelo.</p></span>
    </ReactTooltip>
  );
};

const ModelImgTc = () => {
  return (
    <ReactTooltip delayHide={100} id='modelImgTc' type='info' effect='solid' className="text-center hooverTooltip">
      <span>ARRASTRA Y SUELTA LA IMAGEN DEL TOP CASE</span>
    </ReactTooltip>
  );
};

const PlayVespa = () => {
  return (
    <ReactTooltip delayHide={100} id='pausePlayVespa' type='info' effect='solid' className="text-center hooverTooltip"
                  getContent={(message) => <span>{message}</span>}/>

  );
};
const ShowVespa = () => {
  return (
    <ReactTooltip delayHide={100} id='showVespas' type='info' effect='solid' className="text-center hooverTooltip"
                  getContent={(message) => <span>{message}</span>}/>
  );
};
const MechanicVespa = () => {
  return (
    <ReactTooltip delayHide={100} id='mechanicVespas' type='info' effect='solid' className="text-center hooverTooltip"
                  getContent={(message) => <span>{message}</span>}/>
  );
};

const DeleteVespa = () => {
  return (
    <ReactTooltip id='deleteVespa' type='info' effect='solid' className="text-center">
      <span>ELIMINAR VESPA</span>
    </ReactTooltip>
  );
};

const DeleteBooking = () => {
  return (
    <ReactTooltip place="left" id='deleteBooking' type='info' effect='solid' className="text-center">
      <span>ELIMINAR RESERVA <p>La reserva no será visible para nadie pero no <br/> desaparecerá, seguirá activa aunque no se vea.</p></span>
    </ReactTooltip>
  );
};

const ModifyBooking = () => {
  return (
    <ReactTooltip place="left" id='modifyBooking' type='info' effect='solid' className="text-center">
      <span>MODIFICAR RESERVA  <p>Si la reserva ha sido cancelada<br/> no se puede modificar</p></span>
    </ReactTooltip>
  );
};

const DownloadRentalAgreement = () => {
  return (
    <ReactTooltip place="left" id='downloadRentalAgreement' type='info' effect='solid' className="text-center">
      <span>DESCARGAR CONTRATO DE ALQUILER  <p>Descarga el contrato de alquiler <br/> en PDF</p></span>
    </ReactTooltip>
  );
};

const CancelBooking = () => {
  return (
    <ReactTooltip place="left" id='cancelBooking' type='info' effect='solid' className="text-center">
      <span>CANCELAR RESERVA <p>Si la reserva ha sido cancelada, <br/> no se puede volver a cancelar</p></span>
    </ReactTooltip>
  );
};

const ChangeDate = () => {
  return (
    <ReactTooltip id='changeDate' type='info' effect='solid' className="text-center">
      <span>El cambio de fecha manual ignora <br/> la sobreposición de reservas<p>Antes de modificar la fecha asegurese que la nueva <br/> fecha está disponible para esta vespa en particular</p></span>
    </ReactTooltip>
  );
};

const MoreEmployees = () => {
  return (
    <ReactTooltip id='moreEmployees' type='info' effect='solid' className="text-center">
      <span>CREAR EMPLEADOS</span>
    </ReactTooltip>
  );
};

const MoreClients = () => {
  return (
    <ReactTooltip id='moreClients' type='info' effect='solid' className="text-center">
      <span>CREAR CLIENTES</span>
    </ReactTooltip>
  );
};

const DeleteUser = () => {
  return (
    <ReactTooltip place="left" id='deleteUser' type='info' effect='solid' className="text-center">
      <span>ELIMINAR USUARIO <p>Si el usuario es super o admin, perderá <br/> el acceso a la administración</p></span>
    </ReactTooltip>
  );
};

const ChangeUserRole = () => {
  return (
    <ReactTooltip delayHide={100} id='changeUserRole' type='info' effect='solid' className="text-center hooverTooltip"
                  getContent={(message) => <span>Rol: {message}</span>}/>
  );
};

const SendEmail = () => {
  return (
    <ReactTooltip delayHide={100} id='sendEmail' type='info' effect='solid' className="text-center hooverTooltip"
                  getContent={(email) => <span>Enviar email: {email}</span>}/>
  );
};

//data-tip={true} data-for='moreVespas'
const ToolTip = {
  ModelImgMain,
  ModelImgTc,
  MoreModels,
  MoreVespas,
  PlayVespa,
  ShowVespa,
  MechanicVespa,
  DeleteVespa,
  DeleteBooking,
  ModifyBooking,
  CancelBooking,
  ChangeDate,
  DeleteUser,
  ChangeUserRole,
  MoreEmployees,
  MoreClients,
  SendEmail,
  DownloadRentalAgreement
};

export { ToolTip };
